import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PcmpProjectDetailPage } from '@/features/pcmp/pages/PcmpProjectDetailPage';

export const Route = createFileRoute('/_auth/pcmp/projects/$projectId/')({
  parseParams: ({ projectId }) => {
    const parsedId = Number(projectId);
    if (!Number.isInteger(parsedId) || parsedId <= 0) throw notFound();
    return { projectId: parsedId };
  },
  component: () => (
    <ErrorBoundary moduleName="PCMP Project">
      <PcmpProjectDetailPage />
    </ErrorBoundary>
  ),
});
